
AUI().ready(function () {
  // inlineSVG should be imported through vendors
  if (typeof inlineSVG === 'undefined' || inlineSVG === null) {
      // variable is undefined or null
      console.log("inlineSVG is not defined");
  } else {

      inlineSVG.init(
        {
          svgSelector: "img.svg", // the class attached to all images that should be inlined
          initClass: "js-inlinesvg", // class added to <html>
        },
        function () {
          console.log("All SVGs inlined");
        }
      );
  }

  
  // Handle Mondo BLM slide
  var slider = document.querySelector(".mondo-blm-slider");
  if (slider) {
    new Swiper(".mondo-blm-slider", {
      // Optional parameters
      // direction: "vertical",
      loop: true,
  
      // If we need pagination
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
  
      // Navigation arrows
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
  
      // And if we need scrollbar
      scrollbar: {
        el: ".swiper-scrollbar",
      },
    });
  }

  if (typeof matchHeight === 'undefined' || matchHeight === null) {
  // ReInit matchHeight on every page load
    console.log("matchHeight is not defined");
  } else {
    matchHeight.init();
  }


  // Handle collapsable
  document.querySelectorAll(".collapsable").forEach(function (el) {
    el.addEventListener("click", function () {
      el.classList.toggle("open");
    });
  });

  // Handle mobile menu
  var mobileMenuTrigger = document.querySelector(".header-mobile-menu");
  if (mobileMenuTrigger) {
    mobileMenuTrigger.addEventListener("click", function () {
      var wrapper = document.querySelector(".blm-portale-dipendenti");
      wrapper.classList.toggle("mobile-menu-open");
    });
  }

  document.openSPDoc = function (idMsDocumentInfo,previewMode){
	if(previewMode == null){
		previewMode=false
	}
  	Liferay.Service(
  		'/blm.msdocumentinfo/get-download-url-by-id-ms-document-info',
  		{
  			idMsDocumentInfo: idMsDocumentInfo,
  		    previewMode: previewMode
  		},
  		function(obj) {
  			console.log(obj);
  			if (previewMode){
  			    document.processPreviewUrl(obj,idMsDocumentInfo)
  			} else {
  			    if (!window.open(obj, '_blank')){
                      window.location.href = obj;
  			    }
  			}
  		}
  	);
  }
  
  document.processPreviewUrl = function ( iFrameUrl,idMsDocumentInfo){
	  AUI().use('liferay-portlet-url',function(){
          var baseUrl = Liferay.PortletURL.createURL("/iframe-page");

          baseUrl.setPortletId("it_intesys_blm_iframe_portlet_IFramePortlet");

          baseUrl.setPortletMode("view");

          baseUrl.setWindowState("normal");

          //baseUrl.setPlid(plid)

          var actionURL = Liferay.Util.PortletURL.createActionURL(
              baseUrl.toString(),
            {
                'javax.portlet.action': 'processURLs',
                'p_auth': Liferay.authToken,
                'backUrl' : Liferay.currentURL,
                'iframeURL' : iFrameUrl,
                'idMsDocumentInfo': idMsDocumentInfo,
                'doAsUserId': Liferay.ThemeDisplay.getDoAsUserIdEncoded()
            }
          );

          console.log(actionURL.toString());
          window.open(actionURL.toString(), '_self');
          });
    }
  document.readComunicazione = function (comunicazioneId){
  	Liferay.Service(
  		'/blm.comunicazione/read-comunicazione',
  		{
  			comunicazioneId: comunicazioneId,
  			doAsUserId: Liferay.ThemeDisplay.getDoAsUserIdEncoded()
  		},
  		function(obj) {
  			console.log(obj);
  		}
  	);
  }
  
  document.countNotification = function (){
	  	Liferay.Service(
  			'/blm_obj.blmcustomobject/get-notification-count',
  			{
  			    userId: Liferay.ThemeDisplay.getUserId(),
  			    archived: true
  			},
  			function(obj) {
  				$('.panel-notifications-count').remove();
  				$('.notifiche').prepend('<span class="badge badge-danger panel-notifications-count"><span class="badge-item badge-item-expand">'+obj+'</span></span>')
  			}
  			);
	  }
  
  
});




